import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService, EvetDiscriptonDTO } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createEventDiscription } = EventsApiService();

export const useCreateEventDiscription = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: EvetDiscriptonDTO) => {
            return createEventDiscription(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Event Description has been updated successfully!!");
            },
        },
    );
};
